import React, { useMemo } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { CONFIGURACOES_ACCESS_ROLES } from '../../constants/roles';
import { ROUTES } from '../../routes';
import { CrudStyles } from '../shared/Crud';
import CollapsibleSection from '../shared/CollapsibleSection';
import LogoSettingsForm from './LogoSettingsForm';
import SystemParametersSection from './SystemParametersSection';
import { SectionsStack } from './styles';

const { Container, Header } = CrudStyles;

export default function Configuracoes() {
    const { user } = useAuth();
    const canAccess = useMemo(
        () => (user?.roles || []).some((role) => CONFIGURACOES_ACCESS_ROLES.includes(role)),
        [user?.roles],
    );

    if (!canAccess) {
        return <Navigate to={ROUTES.DASHBOARD} replace />;
    }

    return (
        <Container>
            <Header>
                <h1>Configurações</h1>
            </Header>
            <SectionsStack>
                <CollapsibleSection id="configuracoes-logo" title="Logo da transportadora">
                    <LogoSettingsForm />
                </CollapsibleSection>
                <CollapsibleSection id="configuracoes-parametros" title="Parâmetros do sistema">
                    <SystemParametersSection />
                </CollapsibleSection>
            </SectionsStack>
        </Container>
    );
}
